module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app"
  }, [_c('header-bar', {
    attrs: {
      "user": _vm.user
    }
  }), _vm._v(" "), (_vm.loading) ? _c('div', {
    staticClass: "loading"
  }, [_vm._m(0)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('transition', {
    attrs: {
      "name": "fade",
      "appear": ""
    }
  }, [_c('router-view', {
    attrs: {
      "user": _vm.user,
      "loading": _vm.loading
    }
  })], 1)], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sk-wave"
  }, [_c('div', {
    staticClass: "sk-rect sk-rect1"
  }), _vm._v(" "), _c('div', {
    staticClass: "sk-rect sk-rect2"
  }), _vm._v(" "), _c('div', {
    staticClass: "sk-rect sk-rect3"
  }), _vm._v(" "), _c('div', {
    staticClass: "sk-rect sk-rect4"
  }), _vm._v(" "), _c('div', {
    staticClass: "sk-rect sk-rect5"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-13402f45"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 192
// module chunks = 1